<template>
	<section ref="componentRef"
			 class="flex-module container-fluid flexible-calltoaction">
		<div class="row">
			<div class="col-xs-12">
				<div ref="ctaOneRef"
					 class="cta-one">
					<div class="content-wrapper">
						<div ref="titleOneRef">

							<BaseDisplayTitle v-if="item?.use_custom_content && item?.title"
											  class="so-expand cta-title"
											  tag="h2"
											  :data="item?.title" />

							<h2 v-else
								class="so-expand cta-title">
								Inte<span>r</span>ested in starting a pr<span>o</span>ject?
							</h2>
						</div>

						<baseRichText v-if="item?.use_custom_content && item?.body.length > 1"
									  class="initial-text"
									  :data="item?.body" />

						<p v-else-if="!item?.use_custom_content || !item?.body"
						   class="initial-text">
							We'd love to hear more and chat about how we can elevate with design and development
						</p>

						<baseButton v-if="item?.use_custom_button"
									class="cta-one-button"
									classes="button--secondary colored cta-form-reveal"
									:to="item?.button_url">
							{{ item?.button_title }}
						</baseButton>

						<baseBookButton v-else
										class="cta-one-button"
										classes="button--secondary colored cta-form-reveal"
										:cursor="{ 'custom': true }"
										@mouseenter="wiggletl.pause(0)"
										@mouseleave="resumeWiggleButton">
							Get in touch
						</baseBookButton>

					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		default: () => ({})
	}
})

const { gsap, ScrollTrigger, CustomWiggle } = useGsap()
const { $bus } = useNuxtApp()
const metaStore = useMetaStore()

const componentRef = ref(null)
// const ctaOneRef = ref(null)
// const titleOneRef = ref(null)

const formRevealed = ref(false)
const triggers = {}
let $q, wiggletl, intent

const item = computed(() => props.data?.item)

function decideLogoColor() {
	return formRevealed.value ? { primary: '#FDFDFD', secondary: '#121212' } : { primary: metaStore.activePageColors.foregroundColor, secondary: metaStore.activePageColors.backgroundColor }
}

function animColorLogo() {
	triggers.colorLogo = ScrollTrigger.create({
		id: 'ctaColorLogo',
		trigger: componentRef.value,
		start: 'top top+=75',
		end: 'bottom top+=75',
		markers: false,
		onEnter: () => {
			$bus.$emit('header-change-color', decideLogoColor())
		},
		onEnterBack: () => {
			$bus.$emit('header-change-color', decideLogoColor())
		},
		onLeave: () => {
			$bus.$emit('header-change-color', { primary: '#FDFDFD', secondary: '#121212' })
		},
		onLeaveBack: () => {
			metaStore.overCta = false
			$bus.$emit('header-change-color', { primary: '#121212', secondary: '#FDFDFD' })
		},
	})
}


function resumeWiggleButton() {
	if (typeof intent === 'number') {
		clearTimeout(intent)
	}

	intent = setTimeout(resumeWiggle, 2000)

	function resumeWiggle() {
		wiggletl.play(0)
	}

}
function initAnimWiggleButton() {
	CustomWiggle.create('funWiggle', { wiggles: 10, type: 'anticipate' })
	wiggletl = gsap.timeline({ paused: true, repeat: -1, repeatDelay: 2.5 }).to($q('.cta-one-button'), { duration: 1.75, rotation: 5, ease: 'funWiggle' })

	wiggletl.play()
}

function initAnims() {
	$q = gsap.utils.selector(componentRef.value)

	animColorLogo()
	initAnimWiggleButton()
}

onMounted(() => {
	useAnims(initAnims, triggers)
})
</script>

<style lang="scss" scoped>
.flexible-calltoaction {
	position: relative;
	margin-top: 0;
	margin-bottom: -2px;
	background-color: var(--background-color, $white);
	color: var(--foreground-color, $black);
	transition-property: background-color;
	transition-duration: 0.5s;
	transition-timing-function: ease-in-out;
	overflow: hidden;

	@include universal-side-padding;
	padding-top: rem-calc(100);
	padding-bottom: rem-calc(100);

	@include for-devices-above(md) {
		padding-top: rem-calc(129);
		padding-bottom: rem-calc(129);
	}

	@include for-devices-above(xl) {
		padding-top: rem-calc(200);
		padding-bottom: rem-calc(200);
	}

	*::selection {
		background-color: var(--foreground-color, $black);
		color: var(--background-color, $white);
	}
}

.cta-one {
	width: 100%;
	display: flex;
	justify-content: space-around;

	.cta-title {
		width: 95%;
		text-align: center;
		margin-left: auto;
		margin-right: auto;

		:deep(h2) {
			text-transform: none;
			font-size: rem-calc(28);
			@include no-margin;

			@include for-devices-above(sm) {
				font-size: rem-calc(36);
			}

			@include for-devices-above(md) {
				font-size: rem-calc(46);
			}

			@include for-devices-above(xl) {
				font-size: rem-calc(54);
			}

			@include for-devices-above(xxl) {
				font-size: rem-calc(58);
			}

			@include for-devices-above(sm) {
				width: 100%;
			}
		}
	}

	.content-wrapper {
		width: 100%;
		text-align: center;

		.initial-text {
			font-size: rem-calc(20);
			font-variation-settings: 'wght' 400;
			margin: 0;
			margin-top: rem-calc(24);

			@include for-devices-above(sm) {
				font-size: rem-calc(24);
				margin-top: rem-calc(48);
			}

			@include for-devices-above(md) {
				font-size: rem-calc(36);
				margin-top: rem-calc(60);
			}

			@include for-devices-above(xl) {
				font-size: rem-calc(42);
				margin-top: rem-calc(75);
			}

			@include for-devices-above(xxl) {
				font-size: rem-calc(46);
			}
		}

		.cta-one-button {
			display: inline-block;
			margin-top: rem-calc(48);

			@include for-devices-above(sm) {
				margin-top: rem-calc(60);
			}

			@include for-devices-above(md) {
				margin-top: rem-calc(72);
			}

			@include for-devices-above(xl) {
				margin-top: rem-calc(100);
			}

			@include for-devices-above(xxl) {
				margin-top: rem-calc(120);
			}

			*::selection {
				background-color: var(--background-color, $black);
				color: var(--foreground-color, $white);
			}
		}
	}
}
</style>